import React from "react";
import { Modal, Table } from "antd";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { formatDateToDMY, formatTime12Hour } from "../../utils/tools";

const BookmarkViewModal = ({ open, onClose, data }) => {
    const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];

    if (!data) return null;

    // Flatten folders and verses into rows for the table
    const tableRows = [];
    data.folders.forEach((folder) => {

        const formattedFolderTime = folder.created_at
            ? `${formatDateToDMY(folder.created_at)} ${formatTime12Hour(folder.created_at)}`
            : "-";



        if (folder.verses && folder.verses.length > 0) {
            folder.verses.forEach((verse) => {
                const formattedVerseTime = verse.created_at
                    ? `${formatDateToDMY(verse.created_at)} ${formatTime12Hour(verse.created_at)}`
                    : "-";
                tableRows.push({
                    folderName: folder.folder_name,
                    folderTime: formattedFolderTime,
                    uniqueKey: verse.unique_key,
                    verseTime: formattedVerseTime,
                    id: verse.id,
                });
            });
        } else {
            tableRows.push({
                folderName: folder.folder_name,
                folderTime: formattedFolderTime,
                uniqueKey: "-",
                verseTime: "-",
                id: `folder-${folder.id}`,
            });
        }
    });

    return (
        <Modal
            open={open}
            centered
            onCancel={onClose}
            footer={null}
            title={`${data.user?.name}'s Bookmark Folders & Verses`}
            width={800}
        >
            <table className="table table-bordered w-full">
                <thead>
                    <tr>
                        <th className="text-center">S.No</th>
                        <th className="text-center">Folder Name</th>
                        <th className="text-center">Folder Time</th>
                        <th className="text-center">Verse Key</th>
                        <th className="text-center">Verse Time</th>
                    </tr>
                </thead>
                <tbody>
                    {tableRows.length > 0 ? (
                        tableRows.map((row, index) => (
                            <tr key={row.id}>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">{row.folderName}</td>
                                <td className="text-center">{row.folderTime || "-"}</td>
                                <td className="text-center">{row.uniqueKey}</td>
                                <td className="text-center">{row.verseTime || "-"}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={5} className="text-center">
                                No folders found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </Modal>
    );
};

export default BookmarkViewModal;